import { useState , useRef , useEffect} from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Footer from "./components/Footer";
import HomeScreen from './screens/Home'
import FlowerScreen from './screens/Flower'
import HistoryScreen from './screens/History'
import StationScreen from './screens/Station.js'
import SearchScreen from './screens/Search.js'
import BarrierFreeScreen from './screens/BarrierFree.js'
import Insta360ModalScreen from './screens/Insta360Modal.js'
import FacilityScreen from './screens/Facility.js'
import AudioGuideScreen from './screens/AudioGuide.js'
import {LANGS , PATH} from "./components/constants.js";
import {SharedLangProvider} from './hooks/useSharedLang.js';
import Loading from "./components/Loading.js";
import { useTranslation } from "react-i18next";
import './App.scss';

function App() {
 const [lang , setLang] = useState(LANGS.JAPANESE);
 const { t } = useTranslation();

 const setLanguage = (code: string) => {
    //console.log(code)
    setLang(code);
  }
 const isDisplayedLoading = useRef(false);
 const [isLoading, setIsLoading] = useState(true);
  
 useEffect(() => {
  if(!isDisplayedLoading.current){
    let timeoutId = setTimeout(() => {
      // 5秒経過したら閉じる
      isDisplayedLoading.current = true;
      setIsLoading(false);
    }, 5000)
    return () => {
      clearTimeout(timeoutId)
    }   
  }
  }, [])

  return (
      <BrowserRouter basename={PATH.BASENAME}>
        <SharedLangProvider>
        <div className="content">
        <main>
            <Routes>
              {/* トップページ */}
              <Route path="" element={
                <>
                <Grid container justifyContent="center" alignItems="center" direction="column">
                {isLoading ? 
                <Loading></Loading>:
                <HomeScreen lang={lang} setLang={setLanguage}/>
                }
                </Grid>
                <Footer index={null} />   
                </>
              } />
              {/* 自然にふれる */}
              <Route path="/nature/:id?" element={
                <>
                  <FlowerScreen />
                  <Footer index={0} />                
                </>
              } />
              {/* 歴史にふれる */}
              <Route path="/history/:id?" element={
                <>
                   <HistoryScreen />
                   <Footer index={1} />               
                </>
              } />
              {/* 駅を探す */}
              <Route path="/station/:id?" element={
                <>
                  <StationScreen />
                  <Footer index={3} />
                </>
              } />
              {/* キーワードで探す */}
              <Route path="/search" element={
                <>
                  <SearchScreen />
                  <Footer index={null} />
                </>
              } />
              {/* バリアフリーで探す */}
              <Route path="/barrier-free/:id?/:group?" element={
                <>
                  <BarrierFreeScreen />
                  <Footer index={4} />
                </>
              } />
              {/* 施設で探す */}
              <Route path="/facility/:id?" element={
                <>
                  <FacilityScreen />
                  <Footer index={2} />
                </>
              } />
              <Route path="/modal360" element={
                  <>
                    <Insta360ModalScreen />
                    <Footer index={null} />
                  </>
                } />
              <Route path="/audio-guide" element={
                  <>
                    <AudioGuideScreen />
                    <Footer index={null} />
                  </>
                } />
            </Routes>
            
        </main>
       
        </div>
        </SharedLangProvider>
      </BrowserRouter>
  );
}
export default App;